import { useMutation } from "react-query"

import { buildLaunchCart } from "src/api/DryStack"

import { useToast } from "src/hooks/use_toast"
import { useTracker } from "src/hooks/use_tracker"

// The launches page runs on a hash router and POS runs on its own browser
// router under /point_of_sale, so react-router cannot carry the dockhand
// across. useServerCart reads cart_id off the query string on the way in.
const useLaunchCart = ({ marinaSlug, trackingProps, genericError }) => {
  const showToast = useToast()
  const tracker = useTracker()

  const { mutate, isLoading } = useMutation(
    ({ encodedId }) => buildLaunchCart(marinaSlug, encodedId),
    {
      onSuccess: (data) => {
        window.location.assign(
          `/manage/${marinaSlug}/point_of_sale?cart_id=${data.cart.id}`
        )
      },
      onError: (error) => {
        tracker.trackEvent("dry_stack_schedule_view:launch_cart_build_failed", {
          ...trackingProps,
          reason: error?.message,
        })
        showToast(error?.message || genericError, { type: "error" })
      },
    }
  )

  const buildCart = (row) => {
    if (isLoading) return

    tracker.trackEvent("dry_stack_schedule_view:launch_cart_started", {
      ...trackingProps,
    })
    mutate({ encodedId: row.encodedId })
  }

  return { buildCart, isBuildingCart: isLoading }
}

export default useLaunchCart
